import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let DelConfirm = class DelConfirm extends Vue {
    hide(r) {
        this.close(r || false);
    }
};
tslib_1.__decorate([
    Prop()
], DelConfirm.prototype, "close", void 0);
tslib_1.__decorate([
    Prop()
], DelConfirm.prototype, "goodsInfo", void 0);
DelConfirm = tslib_1.__decorate([
    Component
], DelConfirm);
export default DelConfirm;
